import { Pipe, PipeTransform } from '@angular/core';

import { Product } from '@bytel/bytel-sales';

import { MainCartService } from '@services/main-cart.service';

@Pipe({
    name: 'qytCount',
    standalone: true,
})
export class QtyCountPipe implements PipeTransform {
    public constructor(private cartService: MainCartService) {}

    public transform(products: Product[]): number {
        return products.reduce((count: number, product: Product) => {
            const qty: number = this.cartService.getProductQty(product);
            return count + qty;
        }, 0);
    }
}
